import Vue from "vue";
import VueRouter from "vue-router";
import ErrorPage from "@/views/ErrorPage";
import Home from "@/views/Home";
import masterClasses from "./modules/master-classes";
import admin from "./modules/admin";

Vue.use(VueRouter);

const routes = [
  ...masterClasses,
  ...admin,
  {
    path: "/",
    component: Home,
    name: "Home",
  },
  {
    path: "/:catchAll(.*)",
    component: ErrorPage,
    name: "NotFound",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.afterEach((to) => {
  // Use next tick to handle router history correctly
  // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
  Vue.nextTick(() => {
    document.title = to.meta.tabTitle || `Booking${to.fullPath}`;
  });
});

export default router;
